import Slider from "react-slick";
import partnercompanyimages from "../../assets/partnercompanyimages";
import Image from "../../shared/image/Image";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CustomerCarousel = () => {
  const allLogos = partnercompanyimages.flat();

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 3000,
    cssEase: "linear",
    arrows: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <div className="image-slider-container">
      <Slider {...settings}>
        {allLogos.map((src, i) => (
          <div key={i} className="!flex items-center justify-center px-1">
            <img
              src={src}
              alt={`partner-${i}`}
              className="h-16 rounded-md object-contain brightness-[5] contrast-200 drop-shadow-[0px_2px_6px_black] grayscale"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CustomerCarousel;
